import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function toBeEqualTo(expectedValue: any, errorText: string = '', code: string = '300'): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const currentValue = control.value;

    if (currentValue !== expectedValue) {
      return {
        description: errorText,
        code,
      };
    }
    return null;
  };
}
